/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Categories_LabelInputs */

const en_directory_vibebids_categories_label = /** @type {(inputs: Directory_Vibebids_Categories_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ranking categories`)
};

const zh_directory_vibebids_categories_label = /** @type {(inputs: Directory_Vibebids_Categories_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`榜单分类`)
};

/**
* | output |
* | --- |
* | "Ranking categories" |
*
* @param {Directory_Vibebids_Categories_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_categories_label = /** @type {((inputs?: Directory_Vibebids_Categories_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Categories_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_categories_label(inputs)
	return zh_directory_vibebids_categories_label(inputs)
});
export { directory_vibebids_categories_label as "directory.vibebids.categories_label" }